export const ONE_MINUTE = 1000 * 60;
